<template>
  <v-container class="formulario-wrapper" fluid style="background-color: #f4f7f6; min-height: 100vh;">
    <v-card class="elevation-2">
      <v-card-text class="pt-0">
        <v-form ref="form">

        <div class="d-flex align-center mt-3 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-account-outline</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              CLIENTE
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>
          <v-row align="center">
            <v-col cols="4" sm="2">
              <v-text-field 
                v-model.number="coleta.orsidcliente" 
                label="Código" 
                outlined dense hide-details 
                type="number"
                min="0"
                @keydown="bloquearCaracteresInvalidos"
                @input="garantirPositivo('cliente')"
                :error="['Cliente não encontrado', 'Erro no Banco'].includes(coleta.nomeCliente)"
              ></v-text-field>
            </v-col>
            <v-col cols="1" sm="1" class="d-flex justify-center">
              <v-btn fab small color="primary" elevation="1" @click="pesquisarCliente" >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="7" sm="9">
              <v-text-field 
                v-model="coleta.nomeCliente" 
                label="Nome do Cliente" 
                outlined dense hide-details readonly background-color="#FFF9C4"
                :error="['Cliente não encontrado', 'Erro no Banco'].includes(coleta.orsidcliente)"
              ></v-text-field>
            </v-col>
          </v-row>


      <text-area-rows
        class="mt-4"
        v-model="coleta.orsobservacaogeral"
        label="Defeito"
        outlined
        counter
        maxlength="300"
        background-color="white"
      >
      </text-area-rows>


      <v-text-field class="mb-5 mt-1 nroexterno" label="Nro Externo (opcional)"  hide-details
      outlined
      dense
      maxlength="10"
      type="tel"
      v-model="coleta.orsnroexterno"
      @keypress="$_isNumber"
      ></v-text-field>

      <v-row>
        <v-col cols="12" class="py-0">
          <v-checkbox
            v-model="mostrarObservacao"
            label="Adicionar observação extra"
            hide-details
            dense
            class="mt-0"
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row v-if="mostrarObservacao" class="mt-2">
        <v-col cols="12">
          <v-textarea
            v-model="coleta.observacaoExtra"
            label="Observação Extra"
            outlined
            hide-details
            rows="3"
            background-color="lighten-5"
          ></v-textarea>
        </v-col>
      </v-row>

          <div class="d-flex align-center mt-6 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-package-variant-closed</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              PRODUTO
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>
          <v-row align="center">
            <v-col cols="4" sm="2">
              <v-text-field 
                v-model="coleta.idProduto" 
                label="Código" 
                outlined dense hide-details type="number" 
                :disabled="!coleta.orsidcliente"
                :error="['Produto não encontrado', 'Erro no Banco'].includes(coleta.nomeProduto)"
              ></v-text-field>
            </v-col>
            <v-col cols="1" sm="1" class="d-flex justify-center">
              <v-btn fab small color="primary" elevation="1" @click="pesquisarProduto" :disabled="!coleta.orsidcliente">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="7" sm="9">
              <v-text-field 
                v-model="coleta.nomeProduto" 
                label="Produto" 
                outlined dense hide-details readonly background-color="#FFF9C4"
                :disabled="!coleta.orsidcliente"
                :error="['Produto não encontrado', 'Erro no Banco'].includes(coleta.nomeProduto)"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" md="4">
              <v-text-field
                v-model="quantidade"
                label="Quantidade"
                outlined dense hide-details type="number"
                :disabled="!coleta.orsidcliente"
                @focus="limparZeroQuantidade"
                @blur="restaurarZeroQuantidade"
                @keypress="$_isNumber"
              ></v-text-field>
            </v-col>
            <v-col cols="4" md="4">
              <v-text-field
                v-model="precoProdutoFormatado"
                label="Preço"
                :disabled="!coleta.orsidcliente"
                outlined dense hide-details 
              ></v-text-field>
            </v-col>
            <v-col cols="4" md="4">
              <v-text-field
                :value="totalProdutoFormatado"
                label="Total"
                :disabled="!coleta.orsidcliente"
                outlined dense hide-details readonly background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
          </v-row>


        <div class="linha mt-4">
          <text-area-rows
            v-model="coleta.orsobservacao"
            label="Observação do produto (opcional)"
            outlined
            counter
            maxlength="300"
          >
          </text-area-rows>
        </div>

          <div class="d-flex align-center mt-1 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-format-list-bulleted</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              ITENS DO CADASTRO
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>
          
          <v-row>
            <v-col cols="6" class="d-flex justify-start">
              <v-btn color="primary" @click="$_inserir()" :loading="loading" :disabled="!coleta.orsidcliente">
                <v-icon left>mdi-plus</v-icon>
                Adicionar Item
              </v-btn>
            </v-col>

            <v-col cols="6" class="d-flex justify-end">
              <v-btn 
                v-if="$$_botaoSalvar"  
                @click="$_salvar(true)" 
                color="#61af4c" 
                dark 
                class="button" 
                :loading="loading"
                :disabled="!coleta.orsidcliente"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
          
          <v-row v-if="coletaitens.length > 0" class="mt-4">
            <v-col cols="12">
              <simplebar
                data-simplebar
                :autoHide="false"
                class="lista-itens-container elevation-1"
              >
                <v-list class="py-0" flat>
                  <template v-for="(item, index) in coletaitens">
                    <v-list-item 
                      :key="index" 
                      class="px-3"
                      link
                      ripple
                      @click="$_abrirProduto(index)"
                    >
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold text-truncate">
                          {{item?.produto?.procodigointerno}} - {{item?.produto?.prodescricao}}
                          <span v-if="item.osiobservacao" class="grey--text font-weight-regular"> - {{ item.osiobservacao }}</span>
                          
                        </v-list-item-title>

                        <v-list-item-subtitle class="mt-1 d-flex align-center">
                          <span class="mr-4">Qtd: <strong class="black--text">{{item?.osiquantidade}}</strong></span>
                          
                          <span v-if="mediaCountFor(item, index) > 0" class="d-flex align-center blue-grey--text text--darken-1">
                            <v-icon small color="blue-grey" class="mr-2 midia">mdi-camera-outline</v-icon> Mídia
                            {{ mediaCountFor(item, index) }}
                          </span>
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-icon color="grey">mdi-chevron-right</v-icon>
                      </v-list-item-action>
                      
                      
                    </v-list-item>

                    <v-divider v-if="index < coletaitens.length - 1" :key="`divider-${index}`"></v-divider>
                    
                  </template>
                </v-list>
              </simplebar>
            </v-col>
          </v-row>

      </v-form>
      </v-card-text>
    </v-card>

    <!-- Dialog: detalhes do produto + ações rápidas (estilizado) -->
    <v-dialog v-model="produtoModalAberto" max-width="500" content-class="dialog-top" @click:outside="$_closeProdutoModal()">
      <v-card class="rounded-lg" elevation="6">
        
        <v-card-title class="d-flex justify-space-between align-center px-4 py-3" 
          :style="{ backgroundColor: '#4c6faf', color: 'white' }">
          <span class="text-h6 font-weight-medium">Detalhes do Item</span>
          <v-btn icon dark @click="$_closeProdutoModal()" small aria-label="Fechar modal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-5 px-4 pb-2">
          <div v-if="produtoModalIndex !== null">
            
            <v-row dense class="mb-3">
              <v-col cols="6">
                <div class="caption grey--text text--darken-1 mb-1">CÓDIGO</div>
                <div class="subtitle-1 font-weight-bold black--text">
                  {{ coletaitens[produtoModalIndex]?.produto?.proidcortamanhofinal || '---' }}
                </div>
              </v-col>
              <v-col cols="6">
                <div class="caption grey--text text--darken-1 mb-1">QUANTIDADE</div>
                <div class="subtitle-1 font-weight-bold primary--text text-h6" style="line-height: 1;">
                  {{ coletaitens[produtoModalIndex]?.osiquantidade ?? '---' }}
                </div>
              </v-col>
            </v-row>

            <v-divider class="mb-4"></v-divider>

            <div class="mb-4">
              <div class="caption grey--text text--darken-1 mb-1 d-flex align-center">
                <v-icon small left color="grey">mdi-package-variant-closed</v-icon> DESCRIÇÃO
              </div>
              <div class="body-1 font-weight-medium black--text">
                {{ coletaitens[produtoModalIndex]?.produto?.prodescricao || '---' }}
              </div>
            </div>

            <div v-if="coletaitens[produtoModalIndex]?.osiobservacao" class="rounded grey lighten-4 pa-3 mt-4 border">
              <div class="caption grey--text text--darken-2 mb-1 d-flex align-center font-weight-bold">
                <v-icon small left color="grey darken-2">mdi-comment-text-outline</v-icon>
                OBSERVAÇÃO
              </div>
              <div class="body-2" style="white-space: pre-line;">
                {{ coletaitens[produtoModalIndex]?.osiobservacao }}
              </div>
            </div>

          </div>
        </v-card-text>

        <v-card-actions class="px-1 d-flex justify-space-between align-center">
          
          <v-row class="w-100 ma-0 pa-0">
            <v-col cols="4" class="pa-0 d-flex justify-start align-center">
              <v-btn class="py-0 px-2" color="error" text @click.stop="$_onDeletarClick(produtoModalIndex)">
                <v-icon left>mdi-delete-outline</v-icon>
                Remover
              </v-btn>
            </v-col>

            <v-col cols="4" class="pa-0 d-flex justify-end align-center">
              <v-btn color="blue-grey" outlined class="mr-2" @click.stop="$_onAdicionarImagemClick(produtoModalIndex)" height="36">
                <v-icon left>mdi-camera-plus</v-icon>
                Mídia
                <v-badge
                  v-if="mediaCountFor(coletaitens[produtoModalIndex], produtoModalIndex) > 0"
                  :content="mediaCountFor(coletaitens[produtoModalIndex], produtoModalIndex)"
                  color="#4B616C"
                  offset-x="4"
                  offset-y="-4"
                  class="ml-2"
                ></v-badge>
              </v-btn>
            </v-col>

              <v-col cols="4" class="pa-0 d-flex justify-end align-center">
              <v-btn color="primary" elevation="2" @click.stop="$_onEditarClick(produtoModalIndex)" height="36">
                <v-icon left>mdi-pencil</v-icon>
                Editar
              </v-btn>
            </v-col>
          </v-row>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar timeout="2000000" v-if="snackbar" v-model="snackbar">
        <div class="d-flex justify-space-between">
          <p :style="{fontSize: '1em'}" >Salvando a coleta...</p>
          <v-progress-circular color="white" indeterminate></v-progress-circular>
        </div>
    </v-snackbar>

    <!-- Bottom sheet handler - gerencia todos os diálogos em um único componente -->
    <!-- Finalize Dialog -->
    <!-- <BottomSheetHandler
      :aberto.sync="finalizarDialog"
      tipo="finalize"
      :dados="{ observacao: coleta.orsobservacaogeral }"
      @confirmar="$_confirmFinalizar"
      @update:aberto="$_clearHashRoute()"
    /> -->

    <!-- Delete Dialog -->
    <BottomSheetHandler
      :aberto.sync="deletarDialog"
      tipo="delete"
      :dados="{ produtoNome: coletaitens[indexProdutoSelecionado]?.produto?.prodescricao || '' }"
      @confirmar="$_confirmDeletar"
      @update:aberto="$_clearHashRoute()"
    />

    <!-- Edit Dialog -->
    <BottomSheetHandler
      :aberto.sync="editarDialog"
      tipo="edit"
      :dados="produtoEmEdicao"
      @confirmar="$_confirmarEditando"
      @update:aberto="$_clearHashRoute()"
    />

    <!-- Bottom sheet para adicionar imagens - agora usa GerenciadorMidia -->
<v-bottom-sheet v-model="imagemDialog" @click:outside="$_clearHashRoute()">
      <v-card class="rounded-t-xl">
        
        <div class="d-flex justify-center pt-3 pb-1">
          <div style="width: 40px; height: 4px; background-color: #e0e0e0; border-radius: 2px;"></div>
        </div>

        <v-card-title class="headline d-flex justify-space-between align-center px-6 pt-2 pb-2">
          <div class="d-flex align-center">
            <v-icon color="#4c6faf" class="mr-2">mdi-camera-plus-outline</v-icon>
            <span class="font-weight-bold" style="color: #4c6faf; font-size: 1.25rem;">Adicionar Mídia</span>
          </div>
          <v-btn icon color="grey darken-1" small @click="$_cancelImagem()" aria-label="Fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-6 pt-2 pb-4">
          <div class="rounded grey lighten-4 pa-3 mb-4 d-flex align-center">
            <v-icon small color="grey darken-2" class="mr-2">mdi-package-variant-closed</v-icon>
            <span class="text-body-2 grey--text text--darken-2 mr-1">Produto:</span>
            <strong class="text-body-2 black--text text-truncate">
              {{ coletaitens[indexProdutoSelecionado]?.produto?.prodescricao || '---' }}
            </strong>
          </div>

          <GerenciadorMidia
            v-if="indexProdutoSelecionado !== null"
            :chaveItem="getTempKeyForIndex(indexProdutoSelecionado)"
            :midiasIniciais="currentTempMedias"
            @atualizar:midias="$_onGerenciadorAtualizar"
            @abrirCamera="$_iniciarCamera"
            @abrirModalPreview="$_abrirMidiaModal($event)"
          />
        </v-card-text>

        <v-card-actions class="px-6 pb-6 pt-0 justify-end">
          <v-btn 
            text 
            color="grey darken-1" 
            class="text-capitalize font-weight-medium px-4" 
            @click="$_cancelImagem()"
          >
            Fechar
          </v-btn>
        </v-card-actions>
        
      </v-card>
    </v-bottom-sheet>

    <!-- Modal para exibir mídia em fullscreen -->
    <v-dialog v-model="midiaModalAberto" fullscreen hide-overlay transition="slide-y-reverse-transition">
      <v-card style="height: 100%; background-color: #000;">
        <v-card-text class="d-flex flex-column justify-center align-center" style="height: 100%; position: relative;">
          
          <!-- Botão de fechar -->
          <v-btn 
            icon 
            large 
            color="white"
            style="position: absolute; top: 16px; right: 16px; z-index: 10;"
            @click="$_fecharMidiaModal"
          >
            <v-icon large>mdi-close</v-icon>
          </v-btn>

          <!-- Exibição de imagem -->
          <img 
            v-if="midiaModal && midiaModal.tipo === 'image'"
            :src="midiaModal.dados" 
            class="midia-fullscreen"
            style="max-width: 90%; max-height: 90%; object-fit: contain;"
          >

          <!-- Exibição de vídeo (pausado por padrão) -->
          <video 
            v-else-if="midiaModal && midiaModal.tipo === 'video'"
            ref="videoFullscreen"
            controls
            class="midia-fullscreen"
            style="max-width: 90%; max-height: 90%; object-fit: contain;"
          >
            <source :src="midiaModal.dados" type="video/mp4">
          </video>
        </v-card-text>
      </v-card>
    </v-dialog>


<v-dialog
      v-model="sairDialog"
      max-width="350"
      @click:outside="$_clearHashRoute()"
    >
      <v-card>
        <v-card-title class="headline primary warning-title">
          <v-icon left color="white">mdi-alert-circle-outline</v-icon>
          <span class="white--text">Atenção</span>
        </v-card-title>
        
        <v-card-text class="pt-4 black--text text-body-1">
          Você tem certeza que deseja retornar? Todos os dados não salvos serão perdidos.
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="$_clearHashRoute(), sairDialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="$_sair">Retornar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import errorHandler from '@/utils/error-handler';
import {
  mapActions,
  mapGetters, mapMutations, mapState,
} from 'vuex';
import { PRODUTO_QUERIES } from '@/constants/QUERY_FILTERS';
import { getQueryValue } from '@/services/query-string';
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import { geraData } from '@/utils/libutil';
import db from '@/plugins/dexie';
import { ROUTE_CAMERA, ROUTE_COLETA_LISTA } from '@/constants/ROUTES';
import { USER_STORAGE  } from '@/constants/STORAGE'

import { tempMedia } from '@/utils/tempMedia';
import GerenciadorMidia from '@/components/coleta/MediaManager.vue';
import BottomSheetHandler from '@/components/coleta/BottomSheetHandler.vue';
import { SetupEnvioLocal } from '@/utils/atualizalocal';

import TextAreaRows from '@/components/form/components/textarearows/Index.vue'

export default {
  name: 'ViewOrcamentoCadastro',

  components: {
    simplebar,
    GerenciadorMidia,
    BottomSheetHandler,
    TextAreaRows
  },

  props: {
    dados: Object,
  },

  data() {
    return {
      veioDaPesquisa: false,
      mostrarObservacao: false,
      coleta: {
      id: null,
      orsidlocal: null,
      
      orsidvendedor: sessionStorage.getItem('vendedor'),
      orsidcliente: null,
      nomeCliente: '',
      idProduto: null,
      nomeProduto: '',
      orsobservacao: '',
      orsobservacaogeral: '',
      idGrupo: null,
      orsnroexterno: null,
      precoProduto: 0,
      totalProduto: 0,
    },
      coletaitens: [],
      itensexclusao: [],

      keyclientefield: 1,

      finalizando: false,

      descricaoProduto: '',
      descricaoCliente: '',
      quantidade: null,

      produto: '',
      loading: false,
      debounceCliente: null,
      debounceProduto: null,
      debounceId: null,
      processando: false,
      keycliente: 0,

      snackbar: false,
      finalizarDialog: false,
      deletarDialog: false,
      editarDialog: false,
      imagemDialog: false,
      sairDialog: false, 
      midiaModalAberto: false,

      indexProdutoSelecionado: null,
      imagemSelecionada: null,
      produtoEmEdicao: {
        quantidade: null,
        observacao: '',
        imagens: [],
      },

      MAX_FILE_SIZE: 10 * 1024 * 1024,
      midiaModal: null,
      indiceMidiaModal: null,

      arquivosTemp: tempMedia,
      coletaJaCarregada: false,
      produtoModalAberto: false,
      produtoModalIndex: null,

    };
  },

  computed: {
    ...mapGetters({
      $_getFormapagto: 'formapagto/selectById',
      $_getColetaCarregada: 'coleta/coleta',
    }),

    ...mapState({
      $$_prevenda: (state) => state.prevenda.prevenda,
      $$_stateRequest: (state) => state.prevenda.processandoRequest,
      $$_valorTotal: (state) => state.prevenda.valorTotal,
      $$_cacheCliente: (state) => state.cache.cache_cliente,
      $$_cacheProduto: (state) => state.cache.cache_produto,
      $$_produtoMap: (state) => state.cache.cache_produtoMap,
      $$_clienteMap: (state) => state.cache.cache_clienteMap,
      $$_coleta: (state) => state.coleta.coleta,
      $$_coletaitens: (state) => state.coleta.coletaitens,
      $$_coletaObservacoes: (state) => state.coleta.observacoes,
    }),
    
    $$_idcliente() {
      return this.coleta.orsidcliente;
    },
    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    currentTempMedias() {
      const idx = this.indexProdutoSelecionado;
      if (typeof idx !== 'number') return [];
      const item = this.coletaitens[idx];
      if (!item) return [];
      const key = item.id || `idx_${idx}`;
      return this.arquivosTemp[key] || [];
    },
    $$_botaoSalvar() {
      // console.log('COMPUTED SALVAR', this.$_isEmpty(this.$$_coleta) && this.$_isEmpty(this.$$_coletaitens))
      return !this.$_isEmpty(this.$$_coleta) && !this.$_isEmpty(this.$$_coletaitens);
    },

    precoProdutoFormatado: {
      get() {
        const valor = parseFloat(this.coleta.precoProduto) || 0;
        return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      set(novoValor) {
        const apenasNumeros = novoValor.toString().replace(/\D/g, '');
        this.coleta.precoProduto = apenasNumeros ? (parseFloat(apenasNumeros) / 100) : 0;
      }
    },

    totalProdutoFormatado() {
      const qtd = parseFloat(this.quantidade) || 0;
      const preco = parseFloat(this.coleta.precoProduto) || 0;
      const total = qtd * preco;
      return total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    totalGeralColeta() {
      return this.coletaitens.reduce((acc, item) => {
        const qtd = Number(item.osiquantidade) || 0;
        const preco = Number(item.osivalorunitario) || 0;
        return acc + (qtd * preco);
      }, 0);
    }
  },

  methods: {
    ...mapActions({
      $_reloadCache: 'cache/reloadCache',
      $_saveTempColetaData: 'coleta/saveTempColetaData',
      $_restoreTempColetaData: 'coleta/restoreTempColetaData',
      $_clearTempColetaData: 'coleta/clearTempColetaData',
    }),

    ...mapMutations({
      $_clearColeta: 'coleta/CLEAR_COLETA',
      $_clearColetaItens: 'coleta/CLEAR_COLETAITENS',
      $_pushColetaItens: 'coleta/ADD_COLETAITENS',
      $_deletaColetaItens: 'coleta/DEL_COLETAITENS',
      $_setColeta: 'coleta/SET_COLETA',
    }),

    isValidUUID(val) {
      if (typeof val !== 'string') return false;
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(val);
    },

    async buscarCliente(valor) {
      const idNum = parseInt(valor);
      
      if (!valor || isNaN(idNum)) {
        this.coleta.nomeCliente = '';
        this.descricaoCliente = '';
        return;
      }
      
      try {
        let cliente = await db.cliente.where('cliidcliente').equals(String(valor)).first();
        if (!cliente) cliente = await db.cliente.where('cliidcliente').equals(idNum).first();
        if (!cliente) cliente = await db.cliente.get(idNum);

        if (cliente) {
          this.coleta.nomeCliente = cliente.clinome || cliente.nome;
          this.descricaoCliente = cliente.clinome || cliente.nome;
        } else {
          this.coleta.nomeCliente = 'Cliente não encontrado';
          this.descricaoCliente = '';
        }
      } catch (error) {
        console.error("Erro ao buscar cliente:", error);
        this.coleta.nomeCliente = "Erro no Banco";
      }
    },

    $_formatarDinheiro(valor) {
      const num = Number(valor) || 0;
      return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },

    garantirPositivo(campo) {
      if (campo === 'cliente' && this.coleta.orsidcliente < 0) {
        this.coleta.orsidcliente = null;
      }
    },

    verificarRetornoPesquisa() {
      const resultadoStr = sessionStorage.getItem('pesquisaResultado');
      
      if (resultadoStr) {
        try {
          const res = JSON.parse(resultadoStr);

          if (res.tipo === 'Cliente') {
            this.coleta.orsidcliente = Number(res.codigo);
            this.coleta.nomeCliente = res.descricao; 
            this.descricaoCliente = res.descricao;   
          } 
          else if (res.tipo === 'Produto') {
            this.veioDaPesquisa = true;
            
            this.coleta.idProduto = res.id; 
            this.produto = res.id;          
            
            const nomeCerto = res.nome || res.descricao || '';
            this.coleta.nomeProduto = nomeCerto;    
            this.descricaoProduto = nomeCerto;      
            
            if (!this.quantidade) {
              this.quantidade = 1;
            }
          }
        } catch (error) {
          console.error('Erro ao ler retorno da pesquisa:', error);
        } finally {
          sessionStorage.removeItem('pesquisaResultado');
        }
      }

      const produtoCompletoStr = sessionStorage.getItem('produto_selecionado_retorno');
      
      if (produtoCompletoStr) {
        try {
          const prodCompleto = JSON.parse(produtoCompletoStr);
          
          this.coleta.idGrupo = prodCompleto.idgrupo || prodCompleto.proidgrupo || prodCompleto.idGrupo || null;

          const preco = prodCompleto.propreco || prodCompleto.preco || 0;
          if (preco > 0) {
            this.coleta.precoProduto = Number(preco);
          }

        } catch (error) {
          console.error('Erro ao ler produto_selecionado_retorno:', error);
        } finally {
          sessionStorage.removeItem('produto_selecionado_retorno');
        }
      }
    },

    salvarEstadoTemporario() {
      const estadoAtual = {
        formData: this.formData,
        pedidoDexieId: this.pedidoDexieId,
        itensPedido: this.itensPedido
      };
      sessionStorage.setItem('osEmEdicao', JSON.stringify(estadoAtual));
    },

    pesquisarCliente() {
      this.$_salvarDadosTemporarios();
      this.$router.push({ name: 'clientes', query: { tipo: 'Cliente' } });
    },

    bloquearCaracteresInvalidos(e) {
      if (['-', '+'].includes(e.key)) {
        e.preventDefault();
      }
    },

    async buscarProduto(valor) {
      if (!this.coleta.orsidcliente) {
        this.coleta.idProduto = null;
        return;
      }
      
      const idNum = parseInt(valor);
      if (!valor || isNaN(idNum)) {
        this.coleta.nomeProduto = '';
        this.produto = null;
        return;
      }
      
      try {
        let produto = await db.produto.where('procodigointerno').equals(idNum).first();
        if (!produto) produto = await db.produto.where('procodigointerno').equals(String(valor)).first();
        
        if (!produto) produto = await db.produto.where('proidcortamanhofinal').equals(idNum).first();
        if (!produto) produto = await db.produto.get(idNum);

        if (produto) {
          this.coleta.nomeProduto = produto.prodescricao;
          this.coleta.idGrupo = produto.proidgrupo || produto.idgrupo || null;
          
          this.produto = produto.procodigointerno || idNum; 
          this.descricaoProduto = produto.prodescricao;
          
          if (!this.quantidade) this.quantidade = 1;
        } else {
          this.coleta.nomeProduto = 'Produto não encontrado';
          this.produto = null;
        }
      } catch (error) {
        console.error("Erro ao buscar produto:", error);
        this.coleta.nomeProduto = "Erro no Banco";
      }
    },

    pesquisarProduto() {
      if (!this.coleta.orsidcliente) {
        errorHandler('Por favor, informe o cliente antes de pesquisar um produto.');
        return;
      }
      this.$_salvarDadosTemporarios();
      
      sessionStorage.removeItem('pesquisaResultado');
      sessionStorage.removeItem('produto_selecionado_retorno');
      
      this.$router.push({ name: 'produto', query: { tipo: 'Produto' } });
    },

    limparZeroQuantidade() {
      if (this.formData.quantidadeProduto === 0 || this.formData.quantidadeProduto === '0') {
        this.formData.quantidadeProduto = '';
      }
    },

    restaurarZeroQuantidade() {
      if (!this.formData.quantidadeProduto || this.formData.quantidadeProduto === '') {
        this.formData.quantidadeProduto = 0;
      }
    },

    getTempKeyForIndex(index) {
      const item = this.coletaitens[index];
      if (!item) return null;
      return item.id || `idx_${index}`;
    },

    mediaCountFor(value, index) {
      const key = value?.id || `idx_${index}`;
      return (this.arquivosTemp[key] || []).length;
    },


    async $_salvar(finalizar) {
      const idusuario = Number(sessionStorage.getItem('user:useidusuario'));

      if ((!this.coleta.orsidcliente) && finalizar) {
        errorHandler('Cliente não foi informado.');
        return;
      }
      if (this.coletaitens.length === 0 && finalizar) {
        errorHandler('Não existem itens na coleta.');
        return;
      }

      this.finalizando = true;

      const idSeguranca = sessionStorage.getItem('coleta_orsidlocal_atual');
      const idChaveEdicao = this.coleta.orsidlocal || this.coleta.id || idSeguranca;

      console.log('ID Identificado para salvar:', idChaveEdicao);
      const isAtualizacao = !!idChaveEdicao;

      try {
        let idEmpresa = sessionStorage.getItem('empidempresa');
        if (!idEmpresa || idEmpresa === 'null' || idEmpresa === 'undefined') {
          const empresaLocal = await db.empresa.toCollection().first();
          if (empresaLocal) {
            idEmpresa = empresaLocal.idempresa || empresaLocal.empidempresa || empresaLocal.empidnuvem;
            if (idEmpresa) {
              sessionStorage.setItem('empidempresa', idEmpresa);
            }
          }
        }
        const idEmpresaNum = idEmpresa ? parseInt(idEmpresa) : null;

        if (isAtualizacao) {
          let chavePrimariaDoBanco = this.coleta.id;

          if (typeof idChaveEdicao === 'string' && idChaveEdicao.includes('-')) {
            const registroOs = await db.ordemservico.where('orsidlocal').equals(idChaveEdicao).first();
            if (registroOs) {
              chavePrimariaDoBanco = registroOs.id;
            }
          }

          const idFinalUpdate = chavePrimariaDoBanco || idChaveEdicao;

          await db.ordemservico.update(idFinalUpdate, {
            orsidempresa: idEmpresaNum,
            orsidcliente: Number(this.coleta.orsidcliente),
            orsdefeito: this.coleta.orsobservacaogeral,
            orsobservacaoextra: this.mostrarObservacao ? this.coleta.observacaoExtra : null,
            orsnroexterno: this.coleta.orsnroexterno && this.coleta.orsnroexterno !== '' ? this.coleta.orsnroexterno : null,
            orsdatanuvem: null,
            orsdataalteracao: geraData(),
            orsidnuvem: null,
          });

          let imgs;
          for (let index = 0; index < this.coletaitens.length; index++) {
            const item = this.coletaitens[index];
            
            if (item.id && !String(item.id).includes('idx_') && !this.isValidUUID(item.id)) { 
              await db.ordemservicoitem.update(item.id, {
                osiobservacao: item.osiobservacao,
                osiquantidade: Number(item.osiquantidade),
                osivalorunitario: Number(item.osivalorunitario) || 0,
                osidescricao: item.produto.prodescricao,
                osdataalteracao: geraData(),
                osidatanuvem: null,
                osiidnuvem: null,
                osiordem: index + 1,
              });
              
              await this.$_verificarEDeletarImagensRemovidas(item);
              imgs = this.arquivosTemp[item.id] ?? false;
            } else {
              const novoId = await db.ordemservicoitem.add({
                osiidproduto: Number(item.produto.proidcortamanhofinal),
                osidescricao: item.produto.prodescricao,
                osiobservacao: item.osiobservacao,
                osiquantidade: Number(item.osiquantidade),
                osidatainclusao: geraData(),
                osivalorunitario: Number(item.osivalorunitario) || 0,
                osiidusuario: idusuario,
                
                osiidordemservicolocal: this.coleta.orsidlocal || idChaveEdicao, 
                
                osicodigoproduto: Number(item.produto.procodigointerno),
                osidatanuvem: null,
                osiidordemserviconuvem: item.osiidordemserviconuvem ?? null,
                osiidnuvem: null,
                osiordem: index + 1,
              });
              imgs = this.arquivosTemp[this.getTempKeyForIndex(index)] ?? false;
              item.id = novoId;
            }

            if (imgs) {
              for await (const img of imgs) {
                if (!img.datacriacao) {
                  await db.imagem.add({
                    datacriacao: geraData(),
                    relacao: 'ordemservicoitem',
                    relacaoidlocal: item.id,
                    blob: img.blob,
                    nomearquivo: img?.blob?.name,
                    rotaapi: '/imagem/coleta',
                    tipo: img.blob.type.split('/')[0],
                  });
                }
              }
            }
          }

          for await (const exclusao of this.itensexclusao) {
            if (exclusao && !String(exclusao).includes('idx_')) {
              await db.ordemservicoitem.update(exclusao, {
                osiexclusao: 'S',
              });
            }
          }

        } else {
          const uuid = this.uuidSafe();
          const idUsuarioNuvem = sessionStorage.getItem(USER_STORAGE.useidnuvem);

          await db.ordemservico.add({
            orsidvendedor: idUsuarioNuvem ? parseInt(idUsuarioNuvem) : null,
            orsidempresa: idEmpresaNum,
            orsdatacadastro: geraData(),
            orsidcliente: Number(this.coleta.orsidcliente),
            orsdefeito: this.coleta.orsobservacaogeral,
            orsnroexterno: this.coleta.orsnroexterno != '' ? this.coleta.orsnroexterno : null,
            orsobservacaoextra: this.mostrarObservacao ? this.coleta.observacaoExtra : null,
            orsidlocal: uuid,
            orsdatanuvem: null,
            orsidnuvem: null,
          });
          
          for (let index = 0; index < this.coletaitens.length; index++) {
            const item = this.coletaitens[index];
            
            const id = await db.ordemservicoitem.add({
              osiidproduto: Number(item.produto.proidcortamanhofinal),
              osiobservacao: item.osiobservacao,
              osiquantidade: Number(item.osiquantidade),
              osidescricao: item.produto.prodescricao,
              osidatainclusao: geraData(),
              osivalorunitario: Number(item.osivalorunitario) || 0,
              osiidusuario: idusuario,
              osiidordemservicolocal: uuid,
              osicodigoproduto: item.produto.procodigointerno,
              osidatanuvem: null,
              osiidordemserviconuvem: item.osiidordemserviconuvem ?? null,
              osiidnuvem: null,
              osiordem: index + 1,
            });

            const key = this.getTempKeyForIndex(index);
            if (this.arquivosTemp[key] && this.arquivosTemp[key].length > 0) {
              for await (const img of this.arquivosTemp[key]) {
                if (!img.dexie) {
                  await db.imagem.add({
                    datacriacao: geraData(),
                    relacao: 'ordemservicoitem',
                    relacaoidlocal: id,
                    blob: img?.blob,
                    nomearquivo: img?.blob?.name,
                    rotaapi: 'imagem/coleta',
                    tipo: img.blob.type.split('/')[0],
                  });
                }
              }
            }
          }
        }

        sessionStorage.removeItem('coleta_orsidlocal_atual');
        sessionStorage.removeItem('coleta:idcliente');
        sessionStorage.removeItem('coleta:nomecliente');
        
        this.finalizando = true; 
        this.processando = true;

        this.$_clearTempColetaData();

        await this.$_reloadCache('ordemservico');
        await this.$_reloadCache('ordemservicoitem');

        SetupEnvioLocal();

        this.$nextTick(() => {
          this.$router.replace({
            name: ROUTE_COLETA_LISTA.name,
          }).catch(() => {});
        });

      } catch (err) {
        console.error("Erro ao salvar ordem de serviço:", err);
        this.finalizando = false;
        this.processando = false;
      }
    },

    $_onSalvarClick() {

    },

    $_confirmFinalizar(observacao) {
      this.coleta.orsobservacaogeral = observacao;
      this.finalizarDialog = false;
      this.$_clearHashRoute();
      this.$nextTick(() => {
        this.$_salvar(true);
      });
    },

    $_onDeletarClick(index) {
      this.indexProdutoSelecionado = index;
      this.deletarDialog = true;
      window.location.hash = '#deletar'
    },

    $_confirmDeletar() {
      this.deletarDialog = false;
      this.$_closeProdutoModal();
      this.$_clearHashRoute();
      this.$nextTick(() => {
        this.$_remover(this.indexProdutoSelecionado);
        this.indexProdutoSelecionado = null;
      });
    },


    $_onEditarClick(index) {
      this.indexProdutoSelecionado = index;
      const item = this.coletaitens[index];
      this.produtoEmEdicao = {
        quantidade: item.osiquantidade,
        observacao: item.osiobservacao || '',
        preco: item.osivalorunitario || 0,
      };
      this.editarDialog = true;
      window.location.hash = '#editar';
    },

    $_confirmarEditando(dadosEditados) {
      if (this.indexProdutoSelecionado !== null) {
        const item = this.coletaitens[this.indexProdutoSelecionado];
        item.osiquantidade = Number(dadosEditados.quantidade);
        item.osiobservacao = dadosEditados.observacao;
        item.osivalorunitario = Number(dadosEditados.preco);
      }
      this.editarDialog = false;
      this.$_clearHashRoute();
      this.indexProdutoSelecionado = null;
    },

    $_cancelEditar() {
      this.editarDialog = false;
      this.$_clearHashRoute();
      this.indexProdutoSelecionado = null;
      this.produtoEmEdicao = {
        quantidade: null,
        observacao: '',
      };
    },

    $_onAdicionarImagemClick(index) {
      this.indexProdutoSelecionado = index;
      const key = this.getTempKeyForIndex(index);
      if (key && !this.arquivosTemp[key]) this.$set(this.arquivosTemp, key, []);
      this.imagemDialog = true;
      window.location.hash = '#imagem';
    },

    $_onMidiaSelecionada(file) {
      if (!file) return;
      if (file.size > this.MAX_FILE_SIZE) {
        errorHandler(`Arquivo muito grande! Tamanho máximo: 10MB. Arquivo selecionado: ${(file.size / 1024 / 1024).toFixed(2)}MB`);
        this.imagemSelecionada = null;
        return;
      }

      const idx = this.indexProdutoSelecionado;
      const key = this.getTempKeyForIndex(idx);
      if (!key) {
        errorHandler('Nenhum item selecionado para anexar a mídia.');
        this.imagemSelecionada = null;
        return;
      }
      if (!this.arquivosTemp[key]) this.$set(this.arquivosTemp, key, []);

      const reader = new FileReader();
      reader.onload = (e) => {
        const tipo = file.type.startsWith('video') ? 'video' : 'image';
        this.arquivosTemp[key].push({ tipo, dados: e.target.result });
        this.imagemSelecionada = null;
      };
      reader.readAsDataURL(file);
    },

    $_onGerenciadorAtualizar(midias) {
      const idx = this.indexProdutoSelecionado;
      const key = this.getTempKeyForIndex(idx);
      if (!key) return;
      this.$set(this.arquivosTemp, key, midias || []);
      if (this.coletaitens[idx]) {
        this.coletaitens[idx].imagens = midias || [];
      }
    },

    async $_iniciarCamera() {
      this.$_clearHashRoute();
      this.$router.push({
        ...this.$route,
        name: ROUTE_CAMERA.name,
        params: { tipo: 'coleta', id: this.coletaitens[this.indexProdutoSelecionado].id }
      });
    },

    $_abrirProduto(index) {
      if (typeof index !== 'number' || index < 0 || index >= this.coletaitens.length) return;
      this.produtoModalIndex = index;
      this.produtoModalAberto = true;
      window.location.hash = '#produto';
    },

    $_modalEditar() {
      const idx = this.produtoModalIndex;
      if (idx === null) return;
      this.produtoModalAberto = false;
      this.$nextTick(() => {
        this.$_onEditarClick(idx);
      });
    },

    $_modalAdicionarImagem() {
      const idx = this.produtoModalIndex;
      if (idx === null) return;
      this.produtoModalAberto = false;
      this.$nextTick(() => {
        this.$_onAdicionarImagemClick(idx);
      });
    },

    $_modalDeletar() {
      const idx = this.produtoModalIndex;
      if (idx === null) return;
      this.produtoModalAberto = false;
      this.$nextTick(() => {
        this.$_onDeletarClick(idx);
      });
    },

    $_closeProdutoModal() {
      this.produtoModalAberto = false;
      this.produtoModalIndex = null;
      this.$_clearHashRoute();
    },



    $_removerImagem(index) {
      const key = this.getTempKeyForIndex(this.indexProdutoSelecionado);
      if (!key || !this.arquivosTemp[key]) return;
      if (this.arquivosTemp[key].length > index) {
        this.arquivosTemp[key].splice(index, 1);
      }
    },

    $_cancelImagem() {
      if (this.indexProdutoSelecionado !== null) {
        const key = this.getTempKeyForIndex(this.indexProdutoSelecionado);
        if (key) {
          this.coletaitens[this.indexProdutoSelecionado].imagens = this.arquivosTemp[key] || [];
        }
      }

      this.imagemDialog = false;
      this.$_clearHashRoute();
      this.indexProdutoSelecionado = null;
      this.imagemSelecionada = null;
    },

    $_abrirMidiaModal(index) {
      this.indiceMidiaModal = index;
      const key = this.getTempKeyForIndex(this.indexProdutoSelecionado);
      this.midiaModal = key && this.arquivosTemp[key] ? this.arquivosTemp[key][index] : null;
      this.midiaModalAberto = true;
      window.location.hash = "#midia";

      this.$nextTick(() => {
        if (this.$refs.videoFullscreen && this.midiaModal && this.midiaModal.tipo === 'video') {
          this.$refs.videoFullscreen.pause();
        }
      });
    },

    $_fecharMidiaModal() {
      if (this.$refs.videoFullscreen && this.midiaModal.tipo === 'video') {
        this.$refs.videoFullscreen.pause();
        this.$refs.videoFullscreen.currentTime = 0;
      }
      this.midiaModalAberto = false;
      window.location.hash = '#imagens'
      this.midiaModal = null;
      this.indiceMidiaModal = null;
    },

    uuidSafe() {
      if (crypto.randomUUID) {
        return crypto.randomUUID();
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = crypto.getRandomValues
          ? crypto.getRandomValues(new Uint8Array(1))[0] & 15
          : (Math.random() * 16) | 0;

        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    $_onFiltro(e, campo) {
      
      if (campo === 'orsidcliente') {
        if (e !== undefined && e !== null) {
          this.coleta[campo] = e;
        } else if (e === null) {
          this.coleta[campo] = null;
          this.descricaoCliente = null;
        }
      } else if (campo === 'produto') {
        if (e !== undefined && e !== null) {
          this[campo] = e;
        } else if (e === null) {
          this[campo] = null;
          this.descricaoProduto = null;
          this.quantidade = null;
        }
      }
      this.$router.replace({
        path: this.$route.path,
        query: this.$route.query,
        hash: '',
      }).catch(() => {});
    },

    $_onAlterar(e, campo) {
      this[campo] = e;
    },


    async $_produto() {
      let objProduto = null;
      if (this.produto) {
        objProduto = this.$$_produtoMap.get(Number(this.produto)) || this.$$_produtoMap.get(String(this.produto));

        if (!objProduto) {
          objProduto = await db.produto.get(Number(this.produto)) || 
                      await db.produto.where('proidcortamanhofinal').equals(String(this.produto)).first();
        }

        if (objProduto) {
          setTimeout(() => {
            this.descricaoProduto = objProduto.prodescricao;
            this.coleta.nomeProduto = objProduto.prodescricao;
            
            if (!this.quantidade) this.quantidade = 1; 
          });
        } else {
          this.coleta.nomeProduto = 'Produto não encontrado';
        }
      }
      return objProduto || {};
    },

    async $_cliente() {
      try {
        if (!this.$$_idcliente) {
          this.$_clearPrevendaCliente();
          this.descricaoCliente = null;
          this.coleta.nomeCliente = '';
        } else {
          const cliente = await this.$$_clienteMap.get(Number(this.$$_idcliente));
          
          if (cliente) {
            this.descricaoCliente = cliente.clinome;
            this.coleta.nomeCliente = cliente.clinome;
            
            sessionStorage.setItem('coleta:nomecliente', this.descricaoCliente);
            if (!this.coletaJaCarregada) this.$_setColeta({orsidcliente: this.$$_idcliente})
            this.keycliente += 1;

          } else {
            this.descricaoCliente = null;
            this.coleta.nomeCliente = 'Cliente não encontrado';
            errorHandler('Cliente não encontrado.');
          }
        }
      } catch (error) {
        console.log(error);
        this.coleta.orsidcliente = null;
        this.coleta.nomeCliente = 'Erro no Banco';
        errorHandler('Cliente inválido, verifique os dados e envie novamente');
      }
    },

    $_isNumber(evt) {
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      const keyPressed = evt.key;

      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault();
      }
    },

    async $_clearHashRoute() {
      
        
      this.$router.replace({
        path: this.$route.path,
        query: this.$route.query,
      }).catch(() => {});
      
      if (this.produtoModalAberto) window.location.hash = '#produto';
      else window.location.hash = '';
    },

    $_FormataV(valor) {
      console.log(valor);
      return Number(valor?.replace('.', '').replace(',', '.'));
    },

    async $_inserir() {
      if (!this.coleta.orsidcliente) {
        errorHandler('Informe o cliente antes de adicionar um item.');
        return;
      }

      const idProdutoInserir = this.coleta.idProduto;

      if (!idProdutoInserir || !this.quantidade) {
        errorHandler('Produto e quantidade são obrigatórios.');
        return;
      }

      if (Number(this.quantidade) <= 0) {
        errorHandler('A quantidade deve ser maior que zero.');
        return;
      }
      
      this.loading = true;

      try {
        let objProduto = null;
        
        if (this.$$_produtoMap) {
          objProduto = this.$$_produtoMap.get(Number(idProdutoInserir)) || this.$$_produtoMap.get(String(idProdutoInserir));
        }
        
        if (!objProduto) {
          objProduto = await db.produto.where('proidcortamanhofinal').equals(Number(idProdutoInserir)).first()
        }
        
        if (!objProduto) {
          errorHandler('Produto não encontrado no banco de dados.');
          return;
        }

        const idNuvemReal = objProduto.proidcortamanhofinal || objProduto.proprocidnuvem || idProdutoInserir;

        const novoItem = {
          id: this.uuidSafe(),
          osiidproduto: idNuvemReal, 
          
          produto: {
            procodigointerno: objProduto.procodigointerno,
            prodescricao: objProduto.prodescricao || this.coleta.nomeProduto,
            proidcortamanhofinal: idNuvemReal,
            proidproduto: idNuvemReal, 
          },
          osiquantidade: Number(this.quantidade),
          osivalorunitario: Number(this.coleta.precoProduto) || 0,
          osiobservacao: this.coleta.orsobservacao,
          osicodigoproduto: objProduto.procodigointerno,
          osiidordemserviconuvem: this.$$_coleta?.orsidnuvem ?? null,
          osiordem: this.coletaitens.length + 1,
        };

        this.coletaitens.push(novoItem);
        this.$_pushColetaItens(novoItem);

        this.produto = null;
        this.quantidade = null;
        this.descricaoProduto = '';

        this.coleta.idProduto = null;
        this.coleta.nomeProduto = '';
        this.coleta.idGrupo = null;
        this.coleta.precoProduto = 0;
        this.coleta.orsobservacao = '';

        if (this.$refs.inputproduto) {
          this.$refs.inputproduto.$_retorno();
        }
      } catch (error) {
        console.error("Erro ao inserir produto:", error);
        errorHandler('Erro ao buscar o produto para inserção.');
      } finally {
        this.loading = false;
      }
    },

    async $_remover(index) {
      if (typeof index !== 'number' || index < 0 || index >= this.coletaitens.length) {
        return;
      }


      this.itensexclusao.push(await this.coletaitens[index].id);
      delete tempMedia[this.coletaitens[index].id]

      this.coletaitens.splice(index, 1);

      this.$_deletaColetaItens(index);


      this.$nextTick(() => {
      });
    },

    async $_verificarEDeletarImagensRemovidas(item) {
      try {
        const imagensDB = await db.imagem.where({relacaoidlocal: item.id, relacao: 'ordemservicoitem'}).toArray();
        
        if (!imagensDB || imagensDB.length === 0) return;

        const imagensAtuais = (this.arquivosTemp[item.id] || []).map(img => img.nomearquivo);

        for (const imgDB of imagensDB) {
          const foiRemovida = !imagensAtuais.includes(imgDB.nomearquivo);
          
          if (foiRemovida) {
            // console.log(`Deletando imagem removida: ${imgDB.nomearquivo}`);
            await db.imagem.delete(imgDB.id);
          }
        }
      } catch (err) {
        // console.log('Erro ao verificar e deletar imagens removidas:', err);
      }
    },

    async $_carregarColetaExistente() {
      if (this.coletaJaCarregada) return;

      if (this.$$_coleta && Object.keys(this.$$_coleta).length > 0) {
        const coletaCarregada = this.$$_coleta;

        this.coleta.id = coletaCarregada.id || null;
        this.coleta.orsidlocal = coletaCarregada.orsidlocal || null;
        
        if (this.coleta.orsidlocal) {
          sessionStorage.setItem('coleta_orsidlocal_atual', String(this.coleta.orsidlocal));
        } else if (this.coleta.id) {
          sessionStorage.setItem('coleta_orsidlocal_atual', String(this.coleta.id));
        }

        this.coleta.orsidcliente = coletaCarregada.orsidcliente;
        this.coleta.orsobservacaogeral = coletaCarregada.orsdefeito || '';
        this.coleta.orsnroexterno = coletaCarregada.orsnroexterno;

        this.coleta.observacaoExtra = coletaCarregada.orsobservacaoextra || '';
        if (this.coleta.observacaoExtra.trim() !== '') {
          this.mostrarObservacao = true;
        }
        
        
        // console.log('coletaitensvuex', this.$$_coletaitens)

        this.coletaitens = await Promise.all(this.$$_coletaitens.map(async item => {

          let produto = this.$$_produtoMap.get(Number(item.osicodigoproduto)) || this.$$_produtoMap.get(String(item.osicodigoproduto));
          if (!produto) {
            produto = await db.produto.where('procodigointerno').equals(String(item.osicodigoproduto)).first() || {};
          }

          let obj = {
            produto: {
              procodigointerno: produto.procodigointerno || item.osicodigoproduto,
              prodescricao: produto.prodescricao || 'Descrição indisponível',
            },
            osiquantidade: item.osiquantidade,
            osivalorunitario: item.osivalorunitario || item.osipreco || 0,
            osiobservacao: item.osiobservacao,
            id: item.id,
            osiordem: item.osiordem || 0,
            imagens: []
          }
          // console.log(tempMedia[item.id])
          if (tempMedia[item.id]){
            for (const img in tempMedia[item.id]) {
              obj.imagens.push(tempMedia[item.id][img]);
            }
          } else {
            try {
              const imagensDB = await db.imagem.where({relacaoidlocal: item.id, relacao: 'ordemservicoitem'}).toArray();
              if (imagensDB && imagensDB.length > 0) {
                if (!tempMedia[item.id]) {
                  tempMedia[item.id] = [];
                }

                for (const imgDB of imagensDB) {
                  // console.log('imgdb', imgDB);
                  const urlBlob = URL.createObjectURL(imgDB.blob);
                  
                  obj.imagens.push({
                    tipo: imgDB.blob?.type?.startsWith('video') ? 'video' : 'image',
                    dados: urlBlob,
                    nomearquivo: imgDB.nomearquivo,
                    datacriacao: imgDB.datacriacao
                  });
                  
                  const jáExiste = tempMedia[item.id].some(img => img.nomearquivo === imgDB.nomearquivo);
                  if (!jáExiste) {
                    tempMedia[item.id].push({
                      tipo: imgDB.blob?.type?.startsWith('video') ? 'video' : 'image',
                      dados: urlBlob,
                      nomearquivo: imgDB.nomearquivo,
                      datacriacao: imgDB.datacriacao,
                      dexie: imgDB?.id,
                    });
                  }
                }
              }
            } catch (err) {
              // console.log('Erro ao carregar imagens do DB:', err);
            }
          }
          return obj;
        }));
        this.coletaitens.sort((a, b) => a.osiordem - b.osiordem);
        this.coletaJaCarregada = true;

        await this.$nextTick();
        await this.$nextTick();
        // console.log(this.coletaitens);
      }
    },

    $_tratarVoltarAppBar() {
      const temDadosPreenchidos = 
        this.coleta.orsidcliente || 
        this.coleta.idProduto || 
        this.coletaitens.length > 0 || 
        this.coleta.orsobservacaogeral;

      if (temDadosPreenchidos) {
        this.sairDialog = true;
        window.location.hash = '#sair';
      } else {
        this.$_sair();
      }
    },

    $_sair() {
      // console.log('sair');
      this.$router.replace({
        ...this.$route,
        name: ROUTE_COLETA_LISTA.name,
      });
    },

    $_isEmpty(obj) {
      return !obj || Object.keys(obj).length === 0;
    },

    $_salvarDadosTemporarios() {
      try {
        const coletaData = {
          orsidcliente: this.coleta.orsidcliente,
          orsobservacaogeral: this.coleta.orsobservacaogeral,
          observacaoExtra: this.coleta.observacaoExtra,
          mostrarObservacao: this.mostrarObservacao,
          nomeCliente: this.coleta.nomeCliente,
          idProduto: this.coleta.idProduto,
          orsdefeito: this.coleta.orsdefeito,
          orsnroexterno: this.coleta.orsnroexterno != '' ? this.coleta.orsnroexterno : null,
        };

        this.$_saveTempColetaData({
          coletaData,
          coletaItems: JSON.parse(JSON.stringify(this.coletaitens)),
        });

      } catch (err) {
        // console.log('❌ Erro ao salvar dados temporários:', err);
      }
    },

    async $_restaurarDadosTemporarios() {
      try {
        const tempData = await this.$_restoreTempColetaData();
        
        
        if (tempData && tempData.coletaData) {
          this.coleta.orsidcliente = tempData.coletaData.orsidcliente;
          this.coleta.nomeCliente = tempData.coletaData.nomeCliente || '';
          this.coleta.orsobservacaogeral = tempData.coletaData.orsobservacaogeral;
          this.coleta.observacaoExtra = tempData.coletaData.observacaoExtra || '';
          this.mostrarObservacao = tempData.coletaData.mostrarObservacao || false;
          this.coleta.orsdefeito = tempData.coletaData.orsdefeito;
          this.coleta.orsnroexterno = tempData.coletaData.orsnroexterno;

          this.coletaitens = JSON.parse(JSON.stringify(tempData.coletaItems));

          this.$_clearTempColetaData();
          
          return true;
        } else {
          // console.log('⚠️ Nenhum dado temporário para restaurar');
        }
        return false;
      } catch (err) {
        // console.log('❌ Erro ao restaurar dados temporários:', err);
        return false;
      }
    },
  },
  created() {
    this.$root.$on('appbar-solicita-cancelamento', this.$_tratarVoltarAppBar);
    this.processando = true;
    let id = sessionStorage.getItem('idordemserviconuvem');
    if (id === 'null' || id === null || typeof id === 'object') {
      id = getQueryValue(PRODUTO_QUERIES.id, null);
    }

    this.idordemservico = id;
    
    setTimeout(async () => {
      const restaurado = await this.$_restaurarDadosTemporarios();
      if (!restaurado) {
        await this.$_carregarColetaExistente();
      }
      this.verificarRetornoPesquisa();

      this.processando = false;
    }, 0)
  },
  activated() {
    this.verificarRetornoPesquisa();
  },
  beforeDestroy() {
    this.$root.$off('appbar-solicita-cancelamento', this.$_tratarVoltarAppBar);
  },

  beforeRouteLeave(to, from, next) {
    const rotasSeguras = ['camera', 'clientes', 'produto'];

    if (rotasSeguras.includes(to.name)) {
      this.$_salvarDadosTemporarios();
      return next();
    }

    if (!this.sairDialog && !this.finalizando) {
      
      const temDadosPreenchidos = 
        this.coleta.orsidcliente || 
        this.coletaitens.length > 0 || 
        this.coleta.orsobservacaogeral;

      if (temDadosPreenchidos) {
        this.sairDialog = true;
        window.location.hash = '#sair';
        return next(false);
      }
    }

    this.$_clearColeta();
    this.$_clearColetaItens();
    this.$_clearTempColetaData();
    this.coletaJaCarregada = false;
    for (const key in tempMedia) {
        delete tempMedia[key];
    }

    next();
  },

  watch: {
    'coleta.orsidcliente'(novo) {
      sessionStorage.setItem('coleta:idcliente', Number(novo));
      sessionStorage.setItem('idprevendanuvem', this.idprevenda);
      
      if (!novo) {
        this.keycliente += 1;
        this.coleta.nomeCliente = '';
        this.descricaoCliente = null;
        return; 
      }

      clearTimeout(this.debounceCliente);
      this.debounceCliente = setTimeout(() => {
        if (!this.processando) {
          this.buscarCliente(novo);
        }
      }, 400); 
    },

  'coleta.idProduto'(novo) {
    if (!novo) {
      this.coleta.nomeProduto = '';
      this.descricaoProduto = '';
      this.produto = null;
      this.quantidade = null;
      return; 
    }

    if (this.veioDaPesquisa) {
      return;
    }

    clearTimeout(this.debounceProduto);
    this.debounceProduto = setTimeout(() => {
      this.buscarProduto(novo);
    }, 400); 
  },

  async produto() {
    if (this.veioDaPesquisa) {
      this.veioDaPesquisa = false;
      return;
    }

    clearTimeout(this.debounceProduto);
    this.debounceProduto = setTimeout(async () => {
      const validar = await this.$_produto();
      
      if (!validar || Object.keys(validar).length === 0) {
        this.quantidade = null;
        this.descricaoProduto = '';
        if (!this.produto) this.coleta.nomeProduto = ''; 
      }
    }, 500);
  },

    $$_idcliente() {
      sessionStorage.setItem('coleta:idcliente', Number(this.coleta.orsidcliente));
      sessionStorage.setItem('idprevendanuvem', this.idprevenda);
      if (this.coleta.orsidcliente === null) this.keycliente += 1;
      
      clearTimeout(this.debounceCliente);
      this.debounceCliente = setTimeout(async () => {
        const idcliente = Number(this.coleta.orsidcliente);
        if (!this.processando && idcliente) {
          this.$_cliente();
        } else if (!idcliente) {
          this.descricaoCliente = null;
        }
      }, 700);
    },

    $route: {
      deep: true,
      immediate: true,
      handler() {
        if (this.$route?.hash) {
          if (this.$route?.hash === '#editar') this.editarDialog = true;
          if (this.$route?.hash === '#finalizar') this.finalizarDialog = true;
          if (this.$route?.hash === '#deletar') this.deletarDialog = true;
          if (this.$route?.hash === '#imagem') this.imagemDialog = true; this.midiaModalAberto = false;
          if (this.$route?.hash === '#midia') this.midiaModalAberto = true;
          if (this.$route?.hash === '#sair') this.sairDialog = true;
        } else {
          this.editarDialog = false;
          this.finalizarDialog = false;
          this.deletarDialog = false;
          this.imagemDialog = false;
          this.midiaModalAberto = false;
          this.sairDialog = false;
        }
      },
    },

    'coleta.orsobservacaogeral'() {
      if (!this.processando) {
        this.$_salvarDadosTemporarios();
      }
    },

    'coleta.orsobservacao'() {
      if (!this.processando) {
        this.$_salvarDadosTemporarios();
      }
    },
    }
  }
</script>

<style scoped>

.formulario-wrapper {
  background-color: #f5f5f5;
  padding: 32px 16px;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.midia{
  margin-bottom: 0.5px;
}

.v-cardt{
  padding-top: 5px;
}

.v-card {
  max-width: 900px;
  width: 100%;
}

.v-subheader {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 8px;
}

.v-form .v-row {
  margin-bottom: 4px;
}


.lista-itens-container {
  max-height: 400px; 
  border: 1px solid #eee;
  border-radius: 4px;
}

.lista-itens-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
}

.lista-itens-container ::v-deep .simplebar-track.simplebar-horizontal {
  height: 10px !important;
}

.v-cardt{
  padding-top: 5px;
}

.v-card {
  max-width: 900px;
  width: 100%;
}

.v-subheader {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 8px;
}

.v-form .v-row {
  margin-bottom: 4px;
}

.col-codigo {
  flex: 0 0 25%;
  max-width: 25%;
}
.col-botao {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%;
}
.col-descricao {
  padding-left: 18px;
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%;
}

.lista-itens-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
}

.lista-itens-container ::v-deep .simplebar-track.simplebar-horizontal {
  height: 10px !important;
}

.switch-pedido-ativo ::v-deep .v-input--switch__track {
  color: #9dafd1 !important;
  opacity: 0.6;
}

.switch-pedido-ativo ::v-deep .v-input--switch__thumb {
  color: #4c6faf !important;
}

.switch-pedido-ativo ::v-deep .v-input--selection-controls__ripple {
  color: #728ec2 !important;
}

@media (min-width: 600px) {
  .col-codigo {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-botao {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-descricao {
    margin-left: 0;
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
}

::v-deep .v-text-field--outlined .v-input__control .v-input__slot {
  min-height: 40px !important;
}

.total-vermelho ::v-deep input {
  color: red !important;
  font-weight: bold;
}

.divisor-secao {
  border-top: 1px solid #5a5a5a !important;
  border-color: #5a5a5a !important;
  opacity: 0.95;
}
</style>